import type { Integration, IntegrationResponse, IntegrationsResponse } from '@/types/integration';
import apiClient from './apiClient';


export const IntegrationService = {
  async connectIntegration(platform: string, teamId: string, code: string, state?: string): Promise<IntegrationResponse> {
    const response = await apiClient.post(
      `/v1/integrations/${platform}`,
      { code, state }, // request body
      { params: { team_id: teamId } } // query parameters
    );
    return response.data;
  },
  async updateIntegration(teamId: string, integrationId: string, updates: Partial<Integration>): Promise<IntegrationResponse> {
    const response = await apiClient.put(`/v1/integrations/${teamId}/${integrationId}`, updates);
    return response.data;
  },

  async deleteIntegration(integrationId: string): Promise<void> {
    const response = await apiClient.delete(`/v1/integrations/${integrationId}`);
    return response.data;
  },

  async fetchIntegrations(teamId: string, limit: number = 20, cursor: string = ''): Promise<IntegrationsResponse> {
    const response = await apiClient.get(`/v1/integrations`, {
      params: {
        team_id: teamId,
        limit,
        cursor
      }
    });
    return response.data;
  },

  async fecthIntegration(integrationId: string): Promise<IntegrationResponse> {
    const response = await apiClient.get(`/v1/integrations/${integrationId}`);
    return response.data;
  },
};
